import { competitionListTimeEnum } from "app/utils/const";
import "./AsianEventMarketPlaceholder.scss";

type Props = {
  marketId: number;
  line: string;
};

export const AsianEventMarketPlaceholder = (
  props: Props
): React.JSX.Element => {
  const { marketId, line } = props;
  return (
    <div
      className={`asian-market-outer-container--placeholder ${
        line === competitionListTimeEnum.ALL ? "all-view" : ""
      }`}
      key={`${marketId}`}
    ></div>
  );
};

export default AsianEventMarketPlaceholder;
